import { ButtonAsLink } from '@cluey/cluey-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import iconReview from '../../../assets/images/icon-outline-review.svg';
import { SESSION_TIME_FORMAT } from '../../../util/constants';

export const NextOnGoingSchedule = ({ selectedDay, timezone, onChangeClick, startDate }) => {
  const newDate = `${moment(startDate).tz(timezone).format('dddd')}s`;

  const newTime = moment(startDate).tz(timezone).format(SESSION_TIME_FORMAT);

  return (
    <div className="mb-10 border-b border-grey-2 pb-10">
      <h3 className="mb-5 text-lg font-bold tracking-wide">New ongoing schedule</h3>
      <div className="flex items-start">
        <img src={iconReview} alt="icon" className="mr-3" />
        <div className="flex flex-col gap-y-2 text-left">
          <p className="text-lg font-semibold leading-[1.33]">
            {newDate} at {newTime}
          </p>
          <p>Starting from {selectedDay}</p>
          <ButtonAsLink onClick={onChangeClick} className="link text-left">
            Change
          </ButtonAsLink>
        </div>
      </div>
    </div>
  );
};

NextOnGoingSchedule.propTypes = {
  selectedDay: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  onChangeClick: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired /* a momentjs object */,
};
